import { Alert } from "@mui/material";
import { useParams } from "react-router";
import { useCaseFindQuery } from "../../../../../services/scheduleService/schedule-api";
import { useVerificationFindQuery } from "../../../../../services/verifyService/verify-api";

function ApptNote(){
    const {id} = useParams();
    const schedule = useCaseFindQuery(id!);
    const verification = useVerificationFindQuery(id!);
    
    // Check if this is a pre-quote case
    const isPreQuote = verification.data?.verifyAttributes?.isPreQuote;
    
    // For pre-quote cases, get the note from verification notes (user-provided note only)
    // For regular cases, get from schedule visitNotes
    let note: string | undefined;
    
    if (isPreQuote && verification.data?.notes && verification.data.notes.length > 0) {
        // For pre-quotes, display only the user-provided note, not system notes
        // Find notes that are NOT the system "Pre Quote created by" note
        const userNotes = verification.data.notes.filter(n => !n.noteText.startsWith("Pre Quote created by"));
        if (userNotes.length > 0) {
            // Use the first user note (pre-quote notes should typically only have one user note)
            note = userNotes[0].noteText;
        }
    } else {
        // Regular case - get from schedule
        note = schedule.data?.visitNotes.find(i => i.code == 'ApptNote')?.description;
    }
        
    // Only render the Alert if there is a note to display
    if (!note) {
        return null;
    }

    return <Alert sx={{marginTop:'10px', marginBottom:'10px', paddingBottom:'0px'}} color="info">
        Appointment Note:
        <pre style={{marginBottom:'0px', paddingBottom:'0px'}}>{note.trim()}</pre>
    </Alert>
}

export {ApptNote}